export class GlobalClientVariables {
    constructor(){
        this.serverUpdated = false;
    }
}
